import React from "react";
import OnboardingContent from "./Component/OnboardingContent";
import { useOnboardingLogic } from "./hooks/useOnboardingLogic";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";
import { useEffect, useRef } from "react";

export default function Onboardings() {
  const {
    currentStepData,
    direction,
    currentStep,
    totalSteps,
    getCurrentStepSelections,
    getCurrentTextAreaInput,
    handleTextAreaChange,
    isOtherOptionSelected,
    handleOptionSelect,
    handleBack,
    handleContinue,
    canContinue,
    loadingBoardingSurvey,
  } = useOnboardingLogic();

  const Mixpanel = useMixpanel();
  const hasTrackedSurveyShown = useRef(false);

  // Track onboarding survey shown event when component loads (only once)
  useEffect(() => {
    if (!hasTrackedSurveyShown.current && Mixpanel) {
      Mixpanel.trackEvent("onboarding_survey_shown", {
        name: "Onboarding survey shown",
        timestamp: new Date().toISOString(),
      });
      hasTrackedSurveyShown.current = true;
    }
  }, [Mixpanel]);

  // Show loading screen when survey is being submitted
  if (loadingBoardingSurvey) {
    return (
      <div className="h-screen w-full flex justify-center items-center bg-[#000513]">
        <l-waveform size="35" stroke="3.5" speed="1" color="white"></l-waveform>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#000513" }}>
      <OnboardingContent
        step={currentStepData}
        selectedOptions={getCurrentStepSelections()}
        onOptionSelect={handleOptionSelect}
        onBack={handleBack}
        onContinue={handleContinue}
        canContinue={canContinue}
        isOtherOptionSelected={isOtherOptionSelected()}
        textAreaValue={getCurrentTextAreaInput()}
        onTextAreaChange={handleTextAreaChange}
        currentStep={currentStep + 1}
        totalSteps={totalSteps}
        direction={direction}
      />
    </div>
  );
}
